import { PbApiError, readFetchFailure } from 'pb-api-errors';

export { memberFacingMessage } from 'pb-api-errors';

/**
 * A failed call to app-api. `reason` is the envelope's machine-readable half (`errors[0].reason`):
 * callers branch on it to tell two refusals with the same status apart — a declined card from a
 * stale quote, say — and its presence is what proves the API wrote `message` for a person
 * (`memberFacingMessage`, `pb-api-errors`).
 */
export class ApiError extends PbApiError {
    /**
     * The error a failed `$fetch` stands for, read through `readFetchFailure`: its status, and,
     * when the server answered in the v3 envelope, that envelope's sentence (empty when it has
     * none, so the caller's own sentence stands) and reason.
     */
    static fromFetchError(error: unknown): ApiError {
        // An ApiError already carries the status and reason its thrower gave it, on `code` and
        // `reason`, which none of the fetch-shaped lookups below can see: re-deriving them would
        // flatten a deliberate 402/409/422 to a 500 the pages' status branches never match.
        if (error instanceof ApiError) return error;

        const failure = readFetchFailure(error);

        return new ApiError(failure.message, failure.status ?? 500, failure.entry?.reason ?? null);
    }
}
